import { Component, Input, OnInit, Output,EventEmitter } from '@angular/core';
import { LetterContentService } from 'src/app/services/receipts/letterContent/letter-content.service';


@Component({
  selector: 'app-print-letter',
  templateUrl: './print-letter.component.html',
  styleUrls: ['./print-letter.component.less']
})
export class PrintLetterComponent implements OnInit {

  @Input('letterData') data:any
  @Output() outToParentLetter = new EventEmitter<string>() 

  constructor(private LetterContentService:LetterContentService) { }

  public content:any
 async ngOnInit() {
   console.log(this.data)
    let result:any = await this.LetterContentService.GeLetterContent()
    this.content = result.data[0].MAIL_DETAILS
  }

  ngAfterViewInit(){
    this.outToParentLetter.emit("success")
  }

}
